import Countdown from 'react-countdown'
import { FC } from 'react'

import { Typography } from '~ui'
import Template from '../common/template'
import Placeholder from '../common/placeholder'
import {
  formatAuctionEndDate,
  convertDate,
  convertServerDateToClient,
} from '../../../utils/time-new'

import styles from './time-left.module.scss'

const { Text } = Typography

interface TimeLeftComponentProps {
  date: string
  tz: string
  loading?: boolean
  prefix?: string
}

const reload = () => {
  if (window) {
    window.location.reload()
  }
}

const TimeLeftComponent: FC<TimeLeftComponentProps> = ({
  prefix = 'Auction',
  loading,
  date,
  tz,
}) => {
  if (loading) return <Placeholder />

  return (
    <Template iconName="clock" title="Time left">
      <Countdown
        onComplete={reload}
        now={() => new Date().getTime()}
        date={convertServerDateToClient(date)}
        renderer={({ formatted, completed }) => (
          <span className={styles['time-left']}>
            {completed ? (
              `${prefix} Ended`
            ) : (
              <>
                {formatted.days}d &nbsp;{formatted.hours}h &nbsp;{formatted.minutes}m &nbsp;
                {formatted.seconds}s
              </>
            )}
          </span>
        )}
      />
      <Text color="light-gray">{formatAuctionEndDate(convertDate(date), tz)}</Text>
    </Template>
  )
}

export default TimeLeftComponent
